<template>
  <div id="loading">
    <!-- Contenido del componente de loading -->
  </div>
</template>

<script>
import Vue from 'vue';
import { Loading } from 'element-ui';
import Swal from 'sweetalert2';

Vue.use(Loading.directive);

export default {
  mounted() {
    this.showLoading();
  },
  methods: {
    showLoading() {
      Swal.fire({
        html: `
          <div style="display: flex; align-items: center; justify-content: center;"> 
            <img src="/img/others/loading.gif" alt="Loading" style="width: 50px; height: 50px; margin-right: 15px;">
            <div>
              <h3 style="color: #006393;">${this.$t('cargando')}</h3>
            </div>
          </div>`,
        showConfirmButton: false,
        allowOutsideClick: false
      });
    },
    hideLoading() {
      Swal.close();
    }
  },
  beforeDestroy() {
    this.hideLoading();
  }
};
</script>

<style>
#loading {
  min-height: 200px;
  display: flex;
  align-items: center;
}

.el-loading-spinner .path {
  stroke: #66615b !important;
}

.el-loading-mask {
  background: transparent !important;
}
</style>
